module.exports = __webpack_public_path__ + "img/story-vue.74e45ebe.svg";